module.exports = __webpack_public_path__ + "static/media/GoogleSheet.98d84f51.png";